module.exports = __webpack_public_path__ + "static/media/IKCM01.18788bfc.jpg";